export default "__VITE_ASSET__e1d70b8e__"